import React from 'react';
import { Outlet } from 'react-router-dom';
import SidebarNavigation from '../components/SidebarNavigation.jsx';
import {useViewportSize} from '@mantine/hooks';
import {useRecoilState} from 'recoil';
import {userState} from '../store.jsx';
import {useQuery} from '@tanstack/react-query';
import repositories from '../repositories.jsx';
import OfferBanner from "../widgets/OfferBanner.jsx";
import toast from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import {clearSessionData} from '../helpers/AppHelper.jsx';



export default function AppLayout() {
	const {width, height} = useViewportSize()
	const [authMe, setAuthMe] = useRecoilState(userState)
	const navigate = useNavigate();

	const handleAuthError = (error) => {
		const statusCode = error?.response?.status || 'Unknown';
		const errorMessage = error?.response?.data?.message || 'An unknown error occurred.';

		if (statusCode === 400 || statusCode === 401 || errorMessage === 'Invalid credentials') {
			try {
				clearSessionData();
			} catch (err) {
				console.error('Failed to clear session data from localStorage:', err);
			}
			toast.error('Session expired. Please log in again.');
			navigate('/login');
		} else {
			console.error('An error occurred:', errorMessage);
		}
	};

	const fetchAuthUser = async () => {
		try {
			const res = await repositories.auth.me();
			setAuthMe(res);
			localStorage.setItem('email', res?.email);
			return res;
		} catch (error) {
			handleAuthError(error);
		}
	};

	useQuery({
		queryKey: ['auth'],
		queryFn: fetchAuthUser
	});

	const isTrialEnded = () => {
		if (!authMe?.trial_end_date) return false;
		const trialEndDate = new Date(authMe.trial_end_date);
		const currentDate = new Date();
		return currentDate > trialEndDate;
	};

	return (
		<div className="flex min-h-screen bg-gradient-to-br from-violet-50 via-slate-50 to-fuchsia-50">
			<SidebarNavigation />
			<main
				style={{
					height: `${height}px`
				}}
				className="flex-1 bg-transparent overflow-y-auto mx-auto">
				{authMe?.current_plan === 1 && authMe?.trial_status === 'initial' && !isTrialEnded() && (
					<OfferBanner offerActiveStatus={authMe?.offer_active_status} offerEndsInDays={authMe?.offer_ends_in_days} />
				)}
				<div className="px-3 md:px-6">
					<Outlet />
				</div>
			</main>
		</div>
	);
}
